import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import './Calculator-board.css';
import Gel from '../../components/Svgs/Gel'
import { connect } from 'react-redux';
import {
	change,
	initialize,
	Field,
	reduxForm,
	formValueSelector,
} from 'redux-form';
import ReactTooltip from 'react-tooltip'
import FaInfoCircle from 'react-icons/lib/fa/info-circle';
import FaCalendar from 'react-icons/lib/fa/calendar';
import CategoryItem from "./Category-item/Category-item";
import api from "../../api/index";
import DayItem from "./Day-item/DayItem";
import { categoriesData } from "../../actions/categories";
import MobileCategoryItem from './Mobile-Category-Item/MobileCategoryItem';
import MobileDayItem from './Mobile-Day-Item/MobileDayitem'
import PageLoader from '../PageLoader'
import { pageIsLoaded } from '../../actions/pageLoad'

import { getTranslate, getActiveLanguage } from 'react-localize-redux';

// import MobileDayitem from './Mobile-Day-Item/MobileDayItem';

class CalculatorBoard extends Component {
	constructor() {
		super();
		this.state = {
			selectedCar: '',
			selectDay: '',
			productPrice: 0,
			selectedProduct: [],
			dayType: '',
			Categories: [],
			carType: '',
			carTypeId: '',
			dayId: '',
			showPrice: 0,
			popupHeader: '',
			popupContent: '',
		};

	}

	componentDidMount() {

		api.vehicle.categories().then(({ data }) => {
			this.setState({
				Categories: data,
			});
			this.props.dispatch(categoriesData(data));
			data.forEach((categoryItem, index) => {
				if (index === 1) {
					this.setState({
						selectedCar: categoryItem.number,
						carType: categoryItem.number,
						carTypeId: categoryItem.id,
					});
					if (categoryItem.products) {
						categoryItem.products.forEach((productItem, index) => {
							if (index === 0) {
								const obj = {
									selectedProduct: categoryItem.products,
									selectDay: productItem.period,
									dayId: productItem.productId,
									productPrice: productItem.price,
									dayType: productItem.periodType,
									popupHeader: 'category-item-vehicle-header',
									popupContent: 'category-item-vehicle-content',
								}
								this.setState(obj);
							}
						});
					}
				}
			});
			this.props.dispatch(pageIsLoaded(true))
		});
	}

	componentWillUnmount() {
		this.props.dispatch(pageIsLoaded(false))
	}

	OnSelectCar = (name, carType, carTypeId) => {
		localStorage.setItem('vehicleCategoryId', carTypeId);
		this.setState({
			selectedCar: carType,
			carType: carType,
			carTypeId: carTypeId,
			showPrice: 1
		});
		this.getCategory(carType);
	};

	getCategory(carType) {
		let currentCategory = this.state.Categories.filter(category => {
			return category.number === carType;
		});
		if (currentCategory[0].id === 10) {
			this.setState({
				popupHeader: "category-item-motocylce-header",
				popupContent: "category-item-motocylce-content"
			})
		}
		if (currentCategory[0].id === 7) {
			this.setState({
				popupHeader: "category-item-vehicle-header",
				popupContent: "category-item-vehicle-content"
			})
		}
		if (currentCategory[0].id === 9) {
			this.setState({
				popupHeader: "category-item-bus-header",
				popupContent: "category-item-bus-content"
			})
		}
		if (currentCategory[0].id === 8) {
			this.setState({
				popupHeader: "category-item-truck-header",
				popupContent: "category-item-truck-content"
			})
		}
		if (currentCategory[0].id === 11) {
			this.setState({
				popupHeader: "category-item-Trailer-header",
				popupContent: "category-item-Trailer-content"
			})
		}
		if (currentCategory[0].id === 12) {
			this.setState({
				popupHeader: "category-item-special-header",
				popupContent: "category-item-special-content"
			})
		}
		if (currentCategory[0].products) {

			this.setState({
				selectedProduct: currentCategory[0].products
			})
			let currentProduct = currentCategory[0].products.filter(product => {
				return product.period === this.state.selectDay;
			});
			if (currentProduct[0]) {
				this.setState({
					productPrice: currentProduct[0].price,

					selectDay: currentProduct[0].period,
					dayType: currentProduct[0].periodType,
					dayId: currentProduct[0].productId,
				});

			}
		}
	}

	OnSelectDay = item => {
		this.setState(
			{
				selectDay: item.period,
				dayType: item.periodType,
				dayId: item.productId,
				showPrice: 1
			},
			() => {
				this.getCategory(this.state.selectedCar, parseInt(this.state.dayId));
			}
		);
	};

	onBuy = () => {
		setTimeout(() => {
			this.sendInfo()
		}, 0);

		this.props.history.push(this.props.currentLocale.code + "/" + this.props.translate("policiesUrl"));
	};

	sendInfo = () => {
		let FilterProduct = this.state.Categories.filter(item =>
			item.id === this.state.carTypeId
		)
		if (FilterProduct[0]) {
			this.props.dispatch(
				change(
					'CreatePolicyForm',
					'products',
					FilterProduct[0].products
				)
			);
		}
		this.props.dispatch(
			change(
				'CreatePolicyForm',
				'vehicleCategoryId',
				parseInt(this.state.carTypeId)
			)
		);
		localStorage.setItem('vehicleCategoryId', this.state.carTypeId);
		this.props.dispatch(
			change(
				'CreatePolicyForm',
				'fromHome',
				true
			)
		);
		this.props.dispatch(
			change(
				'CreatePolicyForm',
				'dayType',
				this.state.dayType
			)
		);
		this.props.dispatch(
			change('CreatePolicyForm', 'issueDate', parseInt(this.state.dayId))
		);
		this.props.dispatch(
			change(
				'CreatePolicyForm',
				'issueDateDiff',
				parseInt(this.state.selectDay)
			)
		);
		this.props.dispatch(
			change('CreatePolicyForm', 'premium', parseInt(this.state.productPrice))
		);
		this.props.dispatch(change('CreatePolicyForm', 'vehicleCategoryName', this.state.selectedCar));

	}


	changeCar = () => {
		setTimeout(() => {
			let filterCategory = this.state.Categories.filter(item => {
				return item.id === this.props.chassisNumber;

			});
			if (filterCategory[0]) {
				this.OnSelectCar(
					filterCategory[0].name,
					filterCategory[0].number,
					filterCategory[0].id
				);
			}
			// Show 0 Price at starting in mobile
			this.setState({
				showPrice: 1
			})
		}, 200);
	};

	dateChange = item => {
		setTimeout(() => {
			item = this.state.selectedProduct.find(p => p.productId === item.value)
			this.setState(
				{
					selectDay: item.period,
					dayType: item.periodType,
					dayId: item.productId,
					// Show 0 Price at starting in mobile
					showPrice: 1
				},
				() => {
					this.getCategory(this.state.selectedCar, parseInt(this.state.dayId));
				}
			)
		}, 200);
	};

	render() {
		const { handleSubmit, translate } = this.props;
		return (
			<div className="board-container">
				<div className="calculator-board">
					<div className="category-days-content">
						<div className="categories">
							{this.state.Categories.map(item => {
								return (
									<CategoryItem
										name={item.name}
										carType={item.number}
										carId={item.id}
										selectedCar={this.state.selectedCar}
										key={item.id}
										onClick={this.OnSelectCar}
									/>
								);
							})}
						</div>
						<div className="days-content">
							<div className="day-slider">
								{this.state.selectedProduct.map(item => {
									return (
										<DayItem
											item={item}
											key={item.productId}
											selectDay={this.state.selectDay}
											onClick={this.OnSelectDay}
										/>
									);
								})}
							</div>
						</div>
					</div>

					<div className="calculator-content">
						<h1 className="category-price">
							{this.state.productPrice}
							<span><Gel width={15} /></span>
						</h1>
						<div className="category-type">
							{translate(this.state.selectedCar)}

							<a data-tip data-for='sadFace'><FaInfoCircle data-for="infoCircle" place="left"
								className="infoCircle" /></a>
							<ReactTooltip id='sadFace' type="success" effect='solid' place="right">
								<div className="tooltip">

									<div className="category-description-text">
										{translate(this.state.popupHeader)}
										<span>
											{translate(this.state.popupContent)}
										</span>
									</div>
								</div>

							</ReactTooltip>
						</div>
						<p className="category-text">{translate('category')}</p>
						<div className="selected-day">
							<FaCalendar className="calendar" />
							{this.state.selectDay} {translate(this.state.dayType)}
						</div>

						<button className="buy-btn" onClick={this.onBuy}>
							{translate('buy')}
						</button>
					</div>
				</div>
				<div className="board-container-mobile">
					<div className="board-mobile-top">
						<form onSubmit={handleSubmit}>
							<Field
								name="chassisNumber"
								placeholder={"category"}
								labelName={'chassisNumber'}
								onChange={this.changeCar}
								cat={this.state.Categories}
								component={MobileCategoryItem}
								id={2}
								type="text"
							/>

							<Field
								name="chassisDate"
								placeholder={"period"}
								labelName={'chassisDate'}
								options={this.state.selectedProduct.map(item => {
									return {
										value: item.productId,
										label: item.period > 1 ? item.period + " " + translate("day") : item.period + " " + translate("year")
									};
								})}
								onChange={(a) => this.dateChange(a)}
								component={MobileDayItem}
								id={2}
							/>
						</form>
					</div>
					<div className="board-mobile-bottom">
						<h1 className="category-price">
							{this.state.showPrice === 1 ? this.state.productPrice : 0}
							<span> <Gel width={15} /> </span>
						</h1>
						<button className="buy-btn" onClick={this.onBuy}>
							{translate('buy')}
						</button>
					</div>
				</div>
			</div> //  board-container
		);
	}
}

CalculatorBoard = reduxForm({
	form: 'calculatorForm', // a unique identifier for this form
})(CalculatorBoard);
const selector = formValueSelector('calculatorForm');

const mapStateToProps = state => {
	const chassisNumber = selector(state, 'chassisNumber');

	return {
		chassisNumber,
		translate: getTranslate(state.locale),
		calculatorData: state.calculatorData,
		isLoaded: state.isLoaded,
		currentLocale: getActiveLanguage(state.locale)
	};

};

CalculatorBoard = withRouter(CalculatorBoard);
export default connect(mapStateToProps)(CalculatorBoard);



// WEBPACK FOOTER //
// ./src/components/Calculator-board/Calculator-board.js